import WarningBanner from '@/components/WarningBanner';
import { Plan, Touchpoint } from '@/constants/enum';
import { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { useSelector } from 'react-redux';

interface IProps {
  content: React.ReactNode;
  isVisible?: boolean;
  title: string;
  touchPoint?: Touchpoint;
  onDismiss?: () => void;
}

export default function UpgradePlanBanner({ content, isVisible, title, touchPoint, onDismiss }: IProps) {
  // const navigate = useConfirmationNavigate();
  const dataSettings = useSelector(dataSettingsSelector);
  // const trackTouchPoint = useTrackTouchpoint();
  return isVisible ? (
    <WarningBanner
      hideContact
      title={title}
      isVisible={isVisible !== undefined ? isVisible : dataSettings.plan === Plan.FREE}
      removeMargin
      onDismiss={onDismiss}
    >
      <p className="mb-16">{content}</p>
      {/* <Button
        onClick={() => {
          navigate(PATH.PRICING_PLAN);
          if (touchPoint) {
            trackTouchPoint(touchPoint);
          }
        }}
        variant="primary"
      >
        Upgrade now
      </Button> */}
    </WarningBanner>
  ) : null;
}
